var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33317 9.99787C2.73903 10.4589 1.6665 11.3207 1.6665 12.3078C1.6665 13.7805 4.05432 14.9744 6.99984 14.9744C9.94536 14.9744 12.3332 13.7805 12.3332 12.3078C12.3332 11.3207 11.2606 10.4589 9.6665 9.99787M10.9998 5.90778C10.9998 8.2642 7.99984 12.3078 6.99984 12.3078C5.99984 12.3078 2.99984 8.2642 2.99984 5.90778C2.99984 3.55136 4.7907 1.64111 6.99984 1.64111C9.20898 1.64111 10.9998 3.55136 10.9998 5.90778ZM8.33317 5.64111C8.33317 6.37749 7.73622 6.97445 6.99984 6.97445C6.26346 6.97445 5.6665 6.37749 5.6665 5.64111C5.6665 4.90473 6.26346 4.30778 6.99984 4.30778C7.73622 4.30778 8.33317 4.90473 8.33317 5.64111Z",
    stroke: "#455468",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/IconLocation.897d655b1ed65e7dd7407f60d5cbdb80.svg";
export { ForwardRef as ReactComponent };